




















































































import { Component, Vue } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import NotificationEvent from "@/resources/mixins/notifications/notificationEvent";
import { i18n } from "@/resources/locales";
@Component({
  name: "notepad-modal-component",
})
export default class NotepadModalComponent extends mixins(NotificationEvent) {
  showPinRoomModal = false;
  loading = false;
  notes = "";
  oldNotes = "";
  input1 = "";
  input2 = "";
  input3 = "";
  input4 = "";
  pin = null;
  isPin = false;
  error = null;
  isGetOrPut = null;
  timeout = null;
  mounted() {
    this.notes = this.room.notes;
    this.oldNotes = this.room.notes;
    this.pin = localStorage.getItem("pin");
    this.getNotes();
    this.retryGetNotes();
    this.inputsEventListener(1000);
  }
  destroyed() {
    this.removeGetNotes();
  }
  get room() {
    return this.$store.getters["SystemStore/getCurrentRoom"];
  }
  get active() {
    return this.$store.getters["SystemStore/getOpenNotepadModal"];
  }
  set active(e) {
    if (!e && this.isPin) {
      this.isPin = false;
      return;
    }
    this.$store.dispatch("SystemStore/setOpenNotepadModalAction", e);
  }
  onChnage() {
    if (this.notes != this.oldNotes) {
      this.removeGetNotes();
    }
  }
  retryGetNotes() {
    this.timeout = setTimeout(() => {
      this.getNotes();
      this.retryGetNotes();
    }, 3000);
  }
  removeGetNotes() {
    if (this.timeout) clearTimeout(this.timeout);
  }
  sendPin() {
    this.isPin = true;
    this.pin = this.input1 + this.input2 + this.input3 + this.input4;
    this.showPinRoomModal = false;
    localStorage.setItem("pin", this.pin);
    if (this.isGetOrPut == "GET") this.getNotes(true);
    else if (this.isGetOrPut == "PUT") this.updateNotes();
  }
  getNotes(sendPin = false) {
    if (this.room && this.room.id)
      this.$store.dispatch("SpaceStore/getRoomNotesAction", {
        roomId: this.room.id,
        pin: this.pin != null && this.pin != "null" ? parseInt(this.pin) : null,
        callback: (response) => {
          if (response.data.status == "OK") {
            this.notes = response.data.notes;
            this.oldNotes = response.data.notes;
            this.error = null;
          } else if (response.data.status == "KO")
            if (response.data.code == "ERROR_ROOM_INVALID_PIN") {
              this.isGetOrPut = "GET";
              this.error = response.data.code;
              this.showPinRoomModal = true;
              if (sendPin) {
                this.input1 = "";
                this.input2 = "";
                this.input3 = "";
                this.input4 = "";
                this.inputsEventListener(500);
              }
            }
        },
        callbackError: (error) => {},
      });
  }
  updateNotes() {
    localStorage.getItem("pin");
    this.loading = true;
    this.removeGetNotes();
    this.$store.dispatch("SpaceStore/updateRoomNotesAction", {
      roomId: this.room.id,
      data: {
        notes: this.notes,
        pinToJoin:
          this.pin != null && this.pin != "null" ? parseInt(this.pin) : null,
      },
      callback: (response) => {
        if (response.data.status == "OK") {
          this.notes = response.data.notes;
          this.oldNotes = response.data.notes;
          this.error = null;
          this.onSuccess(
            i18n.t("notifications.titles.success"),
            i18n.t("notifications.descriptions.roomUpdate")
          );
          this.retryGetNotes();
        } else if (response.data.status == "KO")
          if (response.data.code == "ERROR_ROOM_INVALID_PIN") {
            this.isGetOrPut = "PUT";
            this.error = response.data.code;
            this.showPinRoomModal = true;
            this.input1 = "";
            this.input2 = "";
            this.input3 = "";
            this.input4 = "";
          }
        this.loading = false;
      },
      callbackError: (error) => {
        this.loading = false;
      },
    });
  }
  inputsEventListener(time = 1000) {
    setTimeout(() => {
      if (this.showPinRoomModal) {
        const inputs = document.querySelectorAll(
          "input.pin-input"
        ) as unknown as HTMLInputElement[];
        inputs[0]?.focus();
        inputs?.forEach((input, key) => {
          if (key !== 0) {
            input.addEventListener("click", () => {
              inputs[0].focus();
            });
          }
          input.addEventListener("keyup", async (e) => {
            if (input.value) {
              var regex = new RegExp("^[0-9]+$");
              if (!regex.test(input.value)) {
                inputs[key].value = "";
                return;
              } else {
                inputs[key].value = input.value;
              }
              if (key === 3) {
                inputs.forEach((input) => (input.className = ""));
                this.sendPin();
              } else {
                inputs[key + 1].value = "";
                inputs[key + 1].focus();
              }
            }
          });
        });
      }
    }, time);
  }
}
